import { Button } from '@cad-arc';
import { useDrawerControls, useDrawerRender } from '../drawers/components/drawer-context-provider';

/**
 * Opens the Sensor Events drawer. Shown in the app header of the map window only, where the
 * sensor panels it opens live.
 */
export function SensorEventsButton(): React.ReactElement {
    const drawerControls = useDrawerControls();
    const drawerRender = useDrawerRender();
    const isOpen = drawerRender?.drawer.type === 'sensor-events';

    return (
        <Button
            isActive={isOpen}
            variant="ghost"
            size="sm"
            onClick={() => {
                if (isOpen) {
                    drawerControls.close();
                } else {
                    drawerControls.open({ type: 'sensor-events', props: {} });
                }
            }}
        >
            Sensor Events
        </Button>
    );
}
